import delivery from './reducers'

export { setDelivery } from './actions'
export { getDelivery } from './selectors'

export default delivery
